import { BRANDING } from "../../shared/branding.js";

export function OpenHares() {
  const primaryLabel = BRANDING.calendarPrimary.label;
  return (
    <section className="page-narrow">
      <h1>Open Hare Dates</h1>
      <p className="muted">
        Want to lead a {primaryLabel} trail? Open dates show up on the calendar with "Hare OPEN" in
        the title — claim one by reaching out via the contact links in the footer.
      </p>
      <p className="callout">
        In a future version you'll be able to request a date in-app, with the Hare Raiser
        confirming or rejecting. For now, the existing contact paths are the way.
      </p>
      <p className="muted">
        See the existing H5 site at{" "}
        <a href="https://hawaii.gotothehash.net/h5.html" target="_blank" rel="noopener noreferrer">
          hawaii.gotothehash.net/h5.html
        </a>{" "}
        — we'll mirror more of its info here as the new site fills out.
      </p>
    </section>
  );
}
